import React, { useState } from "react";
import { AlertTriangle, Trash2 } from "lucide-react";

export function AccountDangerZone({ onDeleteProfile }) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const remove = async () => {
    setBusy(true);
    setError("");
    try {
      await onDeleteProfile();
    } catch (err) {
      setError(err?.message || "Impossibile eliminare il profilo dal server.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="w-full max-w-[1180px] mx-auto p-[18px] pb-10" data-testid="account-danger-zone">
      <div className="card border-2 border-primary p-4">
        <div className="flex items-start gap-3">
          <AlertTriangle className="text-primary shrink-0" size={20} />
          <div className="flex-1">
            <h3 className="font-semibold">Elimina il tuo profilo</h3>
            <p className="text-xs text-muted mt-1">
              Elimina profilo, messaggi, risposte, reazioni, diffusioni, rete e conversazioni dal server; poi cancella i dati del dispositivo e riapre la registrazione.
            </p>
            {!confirming ? (
              <button
                type="button"
                className="mt-3 inline-flex items-center gap-2 rounded-xl border-2 border-primary px-3 py-2 text-sm font-bold text-primary hover:bg-primary hover:text-white"
                onClick={() => setConfirming(true)}
                data-testid="delete-test-profile-btn"
              >
                <Trash2 size={16} /> Elimina il tuo profilo
              </button>
            ) : (
              <div className="mt-3 rounded-xl bg-white border border-edge p-3">
                <p className="text-sm font-semibold">Questa operazione è definitiva. Confermi?</p>
                <div className="flex gap-2 mt-3">
                  <button
                    type="button"
                    className="rounded-lg bg-primary text-white px-3 py-2 text-sm font-bold disabled:opacity-50"
                    onClick={remove}
                    disabled={busy}
                    data-testid="confirm-delete-test-profile-btn"
                  >
                    {busy ? "Eliminazione…" : "Sì, elimina tutto"}
                  </button>
                  <button
                    type="button"
                    className="rounded-lg border border-edge px-3 py-2 text-sm"
                    onClick={() => { setConfirming(false); setError(""); }}
                    disabled={busy}
                  >
                    Annulla
                  </button>
                </div>
              </div>
            )}
            {error && <p className="text-xs text-primary mt-2" role="alert">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
